import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

const Address_Frame = ({ className = "" }) => {
  const navigate = useNavigate();

  const onLogoSImageClick = useCallback(() => {
    navigate("/home-page");
  }, [navigate]);

  const onAboutUsTextClick = useCallback(() => {
    navigate("/about-us");
  }, [navigate]);

  const onServicesTextClick = useCallback(() => {
    navigate("/services");
  }, [navigate]);

  const onCareersTextClick = useCallback(() => {
    navigate("/careers");
  }, [navigate]);

  return (
    <div
      className={`p-4 className="text-deepskyblue-200 font-bold" [background:linear-gradient(-0.06deg,_#041d42,_#101010)] text-left text-11xl text-white font-istok-web mt-12 ${className}`}
    >
      <div className="absolute left-[0px] bottom-[0px] bg-deepskyblue-200 w-full h-[20px]" />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <img
          className="object-cover cursor-pointer w-1/4 lg:w-1/2"
          alt=""
          src="/logo-s@2x.png"
          onClick={onLogoSImageClick}
        />

        <div className="text-6xl">
          <div className="text-deepskyblue-200 cursor-pointer font-bold">QUICK LINKS</div>

          <div onClick={onLogoSImageClick} className="cursor-pointer">Home</div>
          <div onClick={onAboutUsTextClick} className="cursor-pointer">About us</div>
          <div onClick={onServicesTextClick} className="cursor-pointer">Services</div>
          <div onClick={onCareersTextClick} className="cursor-pointer">Careers</div>
        </div>

        <div className="text-6xl">
          <div className="text-deepskyblue-200 font-bold">ADDRESS</div>

          <div>
            A- Wing, Office No.1701,17th Floor, Parinee Crescenzo, behind Ongc,
            G Block, Bandra Kurla Complex, Bandra East, Mumbai, Maharashtra
            400051
          </div>

          <div className="text-deepskyblue-200 font-bold mt-4">
            EMAIL -{" "}
            <span className="text-white font-normal">
              hrsupport@staffsurge.in
            </span>
          </div>

          <div className="text-deepskyblue-200 font-bold mt-4">
            PHONE - <span className="text-white font-normal">022 45243377</span>
          </div>
        </div>
      </div>
    </div>
  );
};

Address_Frame.propTypes = {
  className: PropTypes.string,
};

export default Address_Frame;
